import { wordService } from "../services/wordService";

export const applyKeywords = () => wordService.insertLabeledSemanticBlock("keywords");
export const applyEquation = () => wordService.applySemanticTag({ type: "equation" });
export const applyBlockQuote = () => wordService.applySemanticTag({ type: "blockquote", styleBuiltIn: "Quote" });
